import React from 'react';
import STokenSvg from './STokenSvg';
import { useTheme } from '../contexts/ThemeContext';
import './StreamDisplay.css';

export function STokenLogo({ size = 28 }) {
  const { theme, colorScheme } = useTheme() ?? {};
  return (
    <STokenSvg
      size={size}
      colorScheme={colorScheme || 'default'}
      lightMode={theme === 'light'}
    />
  );
}

export default function StreamDisplay({ streams = 0, showValue = false }) {
  const value = (streams * 0.00166).toFixed(2);
  return (
    <div className="stream-display">
      <STokenLogo size={32} />
      <div className="stream-display__info">
        <span className="stream-display__amount">{streams.toLocaleString()}</span>
        <span className="stream-display__label">Streams</span>
      </div>
      {showValue && (
        <span className="stream-display__value">${value}</span>
      )}
    </div>
  );
}
